import './styles.scss';
import DATA from 'utils/data.json';

const TRAINING_DATA = DATA.training;

const Training = () => {
    return (
        <div className="training">
            <p className='title'>{TRAINING_DATA.title}</p>
            <div className='content'>
                <ul>
                    {TRAINING_DATA.content.map((item, index) => {
                        return (
                            <li key={index} className='training-item' dangerouslySetInnerHTML={{__html: item}}></li>
                        )
                    })}
                </ul>
            </div>
        </div>
    )
}

export default Training;